export default "__VITE_ASSET__Coimf57L__"